export function formatExpiryDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

export const STATUS_LABELS = {
    active: 'Активна',
    expired: 'Истекла',
    expiring_soon: 'Скоро истечёт',
};

export function formatDaysLeft(isoString) {
    const expires = new Date(isoString);
    const days = Math.ceil((expires - Date.now()) / (1000 * 60 * 60 * 24));

    if (days < 0) return null;
    if (days === 0) return 'сегодня';
    if (days === 1) return '1 день';
    if (days >= 2 && days <= 4) return `${days} дня`;
    return `${days} дней`;
}

export function formatRenewedExpiryDate(isoString, periodDays = 31) {
    const expires = new Date(isoString);
    const base = expires < new Date() ? new Date() : expires;
    const renewed = new Date(base.getTime() + periodDays * 86400000);
    return formatExpiryDate(renewed.toISOString());
}
